import request from "@/utils/request"

export default function agentWithdrawToBank(params) {
    return request({
        url: `/fund/withdrawLog/agentWithdrawToBank`,
        params
    })
}
